import React from 'react';

import {
  AboutContainer,
  AboutH1,
  AboutWrapper,
  AboutCard,
  AboutH2,
  Interests,
  StyledIconWrapper,
} from './AboutElements';
import { FaRobot, FaLightbulb, FaEye } from 'react-icons/fa';
import { MdPrecisionManufacturing, MdSensors } from 'react-icons/md';
import {
  GiDeliveryDrone,
  GiTrackedRobot,
  GiMechanicalArm,
} from 'react-icons/gi';
import { IoIosKeypad } from 'react-icons/io';
import { TbRobot } from 'react-icons/tb';
import { SiMicrosoftazure, SiPrintables } from 'react-icons/si';
import { HiChip } from 'react-icons/hi';

const INTERESTS = [
  { icon: <FaRobot />, interest: 'Robotics' },
  { icon: <MdPrecisionManufacturing />, interest: 'Manufacturing' },
  { icon: <GiDeliveryDrone />, interest: 'Drones' },
  { icon: <IoIosKeypad />, interest: 'Robot Operating System' },
  { icon: <GiTrackedRobot />, interest: 'Mobile Robotics' },
  { icon: <GiMechanicalArm />, interest: 'Robotics Manipulators' },
  { icon: <TbRobot />, interest: 'Hybrid Robotics' },
  { icon: <MdSensors />, interest: 'Sensor Fusion' },
  { icon: <SiMicrosoftazure />, interest: 'Mechanical Design' },
  { icon: <FaLightbulb />, interest: 'Product Development' },
  { icon: <SiPrintables />, interest: 'Additive Manufacturing' },
  { icon: <FaEye />, interest: 'Computer Vision' },
  { icon: <HiChip />, interest: 'Edge Computing' },
];

const About = () => {
  return (
    <AboutContainer id="interests">
      <AboutWrapper>
        <AboutH1>Interests</AboutH1>
        <Interests>
          {INTERESTS.map((interest) => (
            <AboutCard key={interest.interest}>
              <StyledIconWrapper>{interest.icon}</StyledIconWrapper>
              <AboutH2>{interest.interest}</AboutH2>
            </AboutCard>
          ))}
        </Interests>
      </AboutWrapper>
    </AboutContainer>
  );
};

export default About;
